export default class SimpleSlider {
  constructor($el, autoSlide = true) {
    this._translateX = 0;
    this.autoSlide = autoSlide;
    this.el = $el;
    this.ul = this.el.find('.blocks-gallery-grid');
    this.indices = null;
    this.slideNum = this.ul.find('.blocks-gallery-item').length;
    this.columns = 1;
    this.autoSlideInterval = null;
    this.activeSlide = 0;

    this.moveSlides = this.moveSlides.bind(this);
    this.moveToSlideNr = this.moveToSlideNr.bind(this);
    this.moveSlidesByArrow = this.moveSlidesByArrow.bind(this);

    this.init();
  }

  set translateX(n) {
    const slidesWidth = (this.ul.width() + 16) * this.slideNum;
    const maxRight = (slidesWidth - (this.el.width() + 1)) * -1;
    if ((n > 0) || (n === maxRight)) {
      this._translateX = maxRight;
      this.activeSlide = this.slideNum - 1;
      this.el.addClass('max-right');
    } else if ((n < maxRight) || (n === 0)) {
      this._translateX = 0;
      this.activeSlide = 0;
      this.el.addClass('max-left');
    } else {
      this._translateX = n;
    }
  }

  get translateX() {
    return this._translateX;
  }

  init() {
    if (this.slideNum >= 2) {
      this.el.addClass('slider-active');
      this.el.find('.slide-arrow').click(this.moveSlidesByArrow);
    }

    const maxHeight = this.el.parent().css('max-height');
    if (maxHeight) {
      this.ul.css('max-height', maxHeight)
    }

    const indices = document.createElement('div');
    indices.className = 'slider-indices';

    for (let n = 0; n < this.slideNum; n++) {
      const dot = document.createElement('div');
      dot.className = 'index-dot';
      if (n === 0) {
        dot.className += ' active-slide';
      }
      dot.dataset.slideNr = n;
      indices.appendChild(dot);
    }
    this.el.append(indices);
    this.indices = this.el.find('.slider-indices');
    if (this.autoSlide) {
      this.autoSlideInterval = setInterval(() => {
        this.moveSlides(-1)
      }, 4000);
    } else {
      jQuery(window).resize(() => this.moveToSlideNr(0));
    }
  }

  updateIndices()
  {
    this.indices.children().removeClass('active-slide');
    this.indices.find(`:nth-child(${this.activeSlide + 1})`).addClass('active-slide');
  }

  moveToSlideNr(n) {
    if (this.columns === this.slideNum) {
      return false;
    }
    const slides = this.ul.find('.blocks-gallery-item')
    const w = slides.width() + 16;
    this.activeSlide = n;
    this.translateX = n * w * -1;
    this.ul.css('transform', `translateX(${this.translateX}px)`);
    this.updateIndices();
  }

  moveSlidesByArrow(e) {
    if (this.columns === this.slideNum) {
      return false;
    }
    let dir = 1;
    if (e.target.className.indexOf('slide-right') > -1) {
      dir = -1;
    }
    this.moveSlides(dir);
  }

  moveSlides(dir) {
    if (this.columns === this.slideNum) {
      return false;
    }
    const slides = this.ul.find('.blocks-gallery-item')
    const w = this.ul.width() + 16;
    this.el.removeClass('max-right').removeClass('max-left');
    this.activeSlide -= dir;
    this.translateX += w * dir;

    this.ul.css('transform', `translateX(${this.translateX}px)`);
    slides.removeClass('active-slide');
    this.updateIndices()
  }
}